var map = {
	"./adopt.svg": "b391",
	"./arrow.svg": "4e21",
	"./birthday.svg": "1230",
	"./charge.svg": "d615",
	"./close-btn.svg": "2c93",
	"./express.svg": "4396",
	"./game.svg": "ef5a",
	"./gift.svg": "22d9",
	"./interact.svg": "5074",
	"./love.svg": "27d8",
	"./new_year.svg": "03aa",
	"./occupy.svg": "5de3",
	"./photo.svg": "4190",
	"./scode.svg": "c342",
	"./send_video.svg": "4bed",
	"./vipmember.svg": "06e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1fa7";